import React, { useEffect, useState } from "react";
import { Accordion, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomBreadCrumbs from "../../../../components/CustomBreadCrumbs";
import {
  BlurWrapperWithSpan,
  SpinnerBlock,
} from "../../../../Utils/CustomComponent";
import useAchData from "../../BankAccountACHPayments/useAchData";
import { TaxFormModal, TaxInfoModal } from "../../BorrowerDashboard/AchPopup";
import ScheduledPaymentsTable from "./ScheduledPaymentsTable";
import OneTimePastPayments from "./OneTimePastPayments";
import { ArrowLeft, PlusCircleFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

const OneTimeACH = () => {
  const [showTaxForm, setShowTaxForm] = useState(false);
  const [showTaxInfo, setShowTaxInfo] = useState(false);

  const accountId = useSelector((state) => state.account.lenderId);

  const { fetchACHData, achData, loading: taxInfoLoading } = useAchData();
  const navigate = useNavigate();

  // const location = useLocation();

  useEffect(() => {
    if (accountId) {
      fetchACHData(accountId);
    }
  }, [accountId]);

  useEffect(() => {
    if (achData?.length) {
      const show = achData[0].DISABLE_YN.toLowerCase() === "y" ? true : false;

      setShowTaxForm(show);
    }
  }, [achData?.length]);

  return (
    <div style={{ overflowY: "scroll" }}>
      {!taxInfoLoading ? (
        <section
          className=" rounded"
          style={{ background: "#eeeeee", minHeight: "100vh" }}
        >
          {/* <div className="p-3 pb-0  mt-1">
            <CustomBreadCrumbs
              crumbs={[
                { title: "Dashboard", link: "/borrower-dashboard-two" },
                { title: "One Time Payment" },
              ]}
            />
          </div> */}
          <article className="container-fluid">
            <div className="p-5 pb-0  mt-1">
              <span
                className="linkClick"
                role="button"
                onClick={() => navigate(-1)}
              >
                <ArrowLeft size={20} /> Back
              </span>{" "}
              / <span>One Time Payment</span>
            </div>
          </article>

          <article className="container-fluid py-5 rounded">
            <section className="bg-white p-5 my-2 mx-4">
              <div className="d-flex align-items-center justify-content-end">
                <Button
                  className="d-flex align-items-center justify-content-center gap-3"
                  onClick={() => navigate("/one-time-payment/form")}
                >
                  <div>
                    <PlusCircleFill />
                  </div>
                  <div>Make a One-Time Payment</div>
                </Button>
              </div>

              <form>
                <div className="loans-in-details mt-5">
                  <div className="">
                    <h6 className="mt-5">Scheduled One Time Payments</h6>
                    <ScheduledPaymentsTable />
                    <div className="row my-5"></div>
                    <h6 className="mt-5">Past One Time Payments</h6>
                    <OneTimePastPayments />
                  </div>
                </div>
              </form>
            </section>
            <TaxFormModal
              show={showTaxForm}
              setShow={setShowTaxForm}
              setShowTaxInfo={setShowTaxInfo}
            />

            <TaxInfoModal
              show={showTaxInfo}
              setShow={setShowTaxInfo}
              achCondition={false}
            />
          </article>
        </section>
      ) : (
        <div style={{ marginTop: "10rem" }}>
          <SpinnerBlock height="50vh" />
        </div>
      )}

      <style>
        {`
          .accordion-button:not(.collapsed) {
          color: #fff; 
          background-color: var(--primary-color);
          }
        `}
      </style>
    </div>
  );
};

export default OneTimeACH;
